const makeSwoosh = (bgColor, highlightColor) => ({
  background: `${bgColor} linear-gradient(105deg, ${bgColor} 0%, ${bgColor} 35%, ${highlightColor} 50%, ${bgColor} 65%, ${bgColor} 100%) no-repeat`,
  backgroundSize: '750px',
  animation: 'swoosh 3s ease-out infinite',
});
// colors generated based on theme.lightText - simple editor at https://codesandbox.io/s/r5pp7pvp6q
const lightPlaceholder = makeSwoosh(
  '#e4e4e4', // color(theme.colors.lightText).lighten(0.3).hex.toString()
  '#fbfbfb', // color(theme.colors.lightText).lighten(0.3).lighten(0.1).hex.toString()
);
const darkPlaceholder = makeSwoosh(
  '#b6b6b6', // color(theme.colors.lightText).darken(0.2).lighten(0.3).hex.toString()
  '#c8c8c8', // color(theme.colors.lightText).darken(0.2).lighten(0.3).lighten(0.1).hex.toString()
);
const placeholderText = {
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    display: 'inline-block',
    left: 0,
    top: '0.45ex',
    height: '1.8ex',
    opacity: 0.4,
  },
  '&::after': {
    // this is just to stretch out the parent so that the absolutely-positioned ::before will
    // work
    content: '""',
    display: 'inline-block',
  },
};

const keyframes = {
  '@keyframes swoosh': {
    '0%': {
      backgroundPosition: '750px 0',
    },
    '60%': {
      backgroundPosition: '750px 0',
    },
    '100%': {
      backgroundPosition: '-750px 0',
    },
  },
};

export default function stylePlaceholders(placeholderProps = {}) {
  return {
    placeholder: Object.keys(placeholderProps).reduce((prevStyles, key) => {
      const { dark, text, ...rest } = placeholderProps[key];
      const placeholder = dark ? darkPlaceholder : lightPlaceholder;
      const extend = [placeholder, rest];
      return {
        ...prevStyles,
        [`& $${key}`]: text ? {
          extend: [placeholderText, {
            '&::before': {
              extend,
            },
          }],
        } : { extend },
      };
    }, {}),
    ...keyframes,
  };
}
